import React, { Suspense, useEffect, useState } from "react";

import style from "./style.module.css";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import Button from "../CommonComponents/Button";
import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import { crossIconGreen } from "../icon_assets";
import Loader from "../CommonComponents/Loader/Loader";
import { useHistory } from "react-router";
import { eventTracker } from "../GATracker3.0/eventTracker";
import {
  NOTIFICATION_CLICKED,
  NOTIFICATION_CLOSED,
  addInfoNotificationValue,
} from "../GATracker3.0/constants";
import useUserDetails from "../CustomHooks/useUserDetails";
import EmailRegisterPopUp from "../Registration/EmailRegisterPopUp";
import EmailLinkSentPopUp from "../Registration/EmailLinkSentPopUp";

const Registration = React.lazy(() => import("../Registration/Registration"));

const NotificationComponent = ({ notifications = [] }) => {
  const [list, setList] = useState(notifications);
  const userData = useUserDetails();
  const [count, setCount] = useState(notifications.length);
  const [data, setData] = useState({});
  const [regShow, setRegShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showEmailVerifyPopUp, setShowEmailVerifyPopUp] = useState(false);
  const [showEmailSentPopUp, setShowEmailSentPopUp] = useState(false);

  const [email, setEmail] = useState("");
  const history = useHistory();
  const modifyData = (obj) => {
    let newObj = {
      title: obj.title,
      subtitle: obj.body,
      buttonText: obj.button_text,
      id: obj.id,
      type: obj.type,
      reference_data: obj.reference_data,
      buttonClick: (dataobj) => {
        eventTracker("event", NOTIFICATION_CLICKED, {
          pagename: "homepage",
          addinfo: addInfoNotificationValue[dataobj.type],
        });
        getNotificationData(dataobj);
        redirectUrl(dataobj);
      },
      crossClick: (dataobj) => {
        getNotificationData(dataobj);
      },
    };
    setData(newObj);
  };
  const redirectUrl = (dataObj) => {
    if (dataObj.type === "LOAN_DISBURSEMENT") {
      history.push("/disbursement/" + dataObj?.reference_data?.sr_id);
    } else if (dataObj.type === "RELEASE_STOCK") {
      history.push(
        "/arya2/release-stock/" +
        dataObj?.reference_data?.warehouse_code +
        "/" +
        dataObj?.reference_data?.commodity_id +
        "/" +
        dataObj?.reference_data?.contract_id
      );
    } else if (dataObj.type === "LEAD_QUOTATION") {
      history.push("/buyer-requirements/" + dataObj?.reference_data?.unique_id);
    } else if (dataObj.type === "SPOT_CONTRACT_CREATION") {
      history.push("/view-contract/" + dataObj?.reference_data?.contract_id);
    } else if (dataObj.type === "COMMODITY_INWARD") {
      history.push("/token-details/" + dataObj?.reference_data?.token_hash);
    } else if (dataObj.type === "EMAIL_VERIFICATION") {
      handleEmailVerifyPopUp();
    } if (dataObj.type === "USER_KYC") {
      setRegShow(true);
    }
  };

  useEffect(() => {
    modifyData(list[0]);
  }, []);

  const getNotificationData = async (data) => {
    let obj = { id: data.id };
    setIsLoading(true);

    const res = await HomePageServices.getUserReadNotification(obj);
    setIsLoading(false);
    if (res?.message === "success") {
      if (list.length !== 1) {
        let abc = list;
        abc.shift();
        setList(abc);
        modifyData(abc[0]);
        setCount(abc?.length);
      } else {
        setList([]);
        setData({});
      }
    }
  };

  const handleEmailVerifyPopUp = () => {
    const data = userData;
    setShowEmailVerifyPopUp(true);
    setEmail(data.email)
  }
  return (
    <>
      <Loader isLoading={isLoading} />
      {regShow && (
        <Suspense fallback={<></>}>
          <Registration show={regShow} setShow={setRegShow} />
        </Suspense>
      )}
      {showEmailVerifyPopUp && <EmailRegisterPopUp setShowEmailVerifyPopUp={setShowEmailVerifyPopUp} showVerifyEmailPopUSent={true} showEmailVerifyPopUp={showEmailVerifyPopUp} setEmail={setEmail} email={email} setShowEmailSentPopUp={setShowEmailSentPopUp} />}
      {showEmailSentPopUp && <EmailLinkSentPopUp
        setShowEmailSentPopUp={setShowEmailSentPopUp}
        showEmailSentPopUp={showEmailSentPopUp}
        email={email}
      />}
      {data?.title ? (
        <div className="margin-left16 margin-right16 margin-bottom16">
          <Card
            className={`justify-content-space-between align-items-center boxRadius8 d-flex positionRelative  ${style["z-index2"]} ${style["cardWithButtonbackGround"]} padding16 `}
          >
            <div className="">
              <HeadLines
                className=" font-weight500 colorAccent2 padding-bottom8"
                text={data.title}
              />
              <HeadLines
                className="colorDark6 font-weight400 font-size12 line-height14 letterSpacing0025"
                text={data.subtitle}
              />
            </div>
            <div className="d-flex">
              <Button
                className={`${style["buttonCSS"]} m-auto padding-bottom8 padding-top8 padding-left16 padding-right16 margin-left6 textColorWhite font-weight400 font-size12 line-height14 letterSpacing0025`}
                title={data.buttonText}
                onClick={() => data.buttonClick(data)}
              />
              <img
                src={crossIconGreen}
                alt=""
                onClick={() => {
                  eventTracker("event", NOTIFICATION_CLOSED, {
                    pagename: "homepage",
                    addinfo: addInfoNotificationValue[data?.type],
                  });
                  data.crossClick(data);
                }}
                className="margin-left16 cursorPointer"
              />
            </div>
          </Card>
          {count > 1 && (
            <div
              className={`${style["commonCSS"]} ${style["z-index1"]} margin-left12 margin-right12 `}
            ></div>
          )}
          {count > 2 && (
            <div
              className={`${style["commonCSS"]} ${style["z-index0"]} margin-left24 margin-right24 `}
            ></div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default NotificationComponent;
